var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"be0ec4ef8735aabfb78fe22f4d15940fa582b0de"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["busbud-pubweb-prod@busbudcom"]={id:"be0ec4ef8735aabfb78fe22f4d15940fa582b0de"};
      